import {GPSPosition} from "@/shared/timr";
import {DeletedStatus} from "@/shared/timrTypes";

/**
 * Returns true if the recording has only deleted gps positions
 * This is used to toggle the gps positions icon
 */
export function onlyDeletedPositionsAvailable(recording: { startPosition?: GPSPosition; endPosition?: GPSPosition }): boolean {
	const {startPosition, endPosition} = recording;
	return positionDeleted(startPosition, endPosition) || positionDeleted(endPosition, startPosition);
}

/**
 * Checks if position is deleted
 * This is the case if there is position 1 is deleted and:
 * - no position 2
 * - position 2 is also deleted
 */
function positionDeleted(position1: GPSPosition, position2: GPSPosition): boolean {
	return position1 && position1.deletedStatus !== DeletedStatus.NOT_DELETED && (
		!position2 || // position 1 is deleted, no position 2 -> deleted
		position2?.deletedStatus === DeletedStatus.DELETED // position 1 is deleted, position 2 is also deleted -> deleted
	);
}

